import type { TOC } from '@ember/component/template-only'

export interface LegendsItem {
  color?: string
  label: string
}

interface LegendsSignature {
  Args: {
    categories?: LegendsItem[]
    title?: string
    multipleCharts?: boolean
  }
  Element: HTMLDivElement
}

export const Legend: TOC<LegendsSignature> = <template>
  <div ...attributes>
    {{#if @title}}
      <h3 class="ml-2 text-left">{{@title}}</h3>
    {{/if}}
    {{#if @categories}}
      <div class="mt-2 flex gap-2">
        {{#each @categories as |category|}}
          <span class="{{if @multipleCharts 'shrink grow basis-0' 'ml-2'}}">
            {{#if category.color}}
              <span class="{{category.color}} mr-1 inline-block h-3 w-3 rounded-full"></span>
            {{/if}}
            {{category.label}}</span>
        {{/each}}
      </div>
    {{/if}}
  </div>
</template>

interface CellSignature {
  Blocks: {
    default: []
  }
  Element: HTMLTableCellElement
}

export const TH: TOC<CellSignature> = <template>
  <th class="h-20 px-3 py-3 text-center align-middle font-normal" role="button" ...attributes>
    {{yield}}
  </th>
</template>

export const TD: TOC<CellSignature> = <template>
  <td class="h-20 px-2" ...attributes>
    {{yield}}
  </td>
</template>
